(() => {
  'use strict';
  document.documentElement.dataset.amcBrandPurchasing='20261027-v2';
  let navRefreshPending=false;
  function refreshNavBrands(){
    navRefreshPending=false;
    if(document.documentElement.hasAttribute('data-uspe-brand'))document.querySelectorAll('#AmcBuyerBar').forEach(bar=>{bar.dataset.quoteOnly='true';bar.querySelector('[data-amc-finpill]')?.remove();bar.querySelector('[data-amc-bb-cart]')?.remove();});
    document.querySelectorAll('.amc-hdr__drawer .amc-hdr__acc').forEach(acc=>{
      if(acc.querySelector('.amc-nav-brand-logos'))return;
      const label=acc.querySelector('summary')?.textContent.replace(/\s+/g,' ').trim().toLowerCase();
      if(!label)return;
      const source=[...document.querySelectorAll('.amc-hdr__nav .amc-hdr__item')].find(item=>{
        const name=item.querySelector('.amc-hdr__link')?.textContent.replace(/\s+/g,' ').trim().toLowerCase()||'';
        return name&&(/autopsy|lab/.test(label)?/autopsy|lab/.test(name):/first\s*call/.test(label)?/first\s*call/.test(name):/prep/.test(label)?/prep/.test(name):name===label);
      });
      const row=source?.querySelector('.amc-nav-brand-logos');
      if(row)acc.querySelector('summary')?.after(row.cloneNode(true));
    });
    if(location.pathname==='/')document.querySelectorAll('.amc-pillrail a[href*="pathology-autopsy-equipment"]').forEach(a=>a.setAttribute('href','/pages/us-pathology-equipment'));
  }
  refreshNavBrands();
  new MutationObserver(()=>{if(!navRefreshPending){navRefreshPending=true;queueMicrotask(refreshNavBrands);}}).observe(document.querySelector('.amc-hdr')||document.body,{childList:true,subtree:true});
  // Keep genuine USPE / veterinary artwork intact; size by visual role, not filename width.
  function balanceLogos(root=document){
    const images=root.matches?.('img')?[root]:root.querySelectorAll?.('img')||[];
    images.forEach(img=>{
      const identity=(img.currentSrc||img.src||'')+' '+img.alt+' '+img.className;
      if(!/uspe|u\.?s\.?\s*pathology/i.test(identity)||!/logo|wordmark|__brand|vet-mark/i.test(identity))return;
      const role=img.closest('.amc-hdr__logo')?'header':
        img.closest('.uspe-hub-identities,.uspe-brand-pair')?'identity':
        img.closest('.amc-nav-brand-logos,.amc-hdr__drawer,.amc-hdr__mega')?'menu':
        img.closest('footer,.amc-ftr')?'footer':
        img.closest('.amc-acct-pop,.amc-cart-empty')?'support':'panel';
      img.dataset.uspeLogoRole=role;
      img.dataset.uspeLogoKind=/vet|veterinary|animal care/i.test(identity)?'vet':'uspe';
      if(img.naturalWidth&&img.naturalHeight){img.width=img.naturalWidth;img.height=img.naturalHeight;}
    });
  }
  balanceLogos();
  document.addEventListener('load',event=>{if(event.target instanceof HTMLImageElement)balanceLogos(event.target);},true);
  document.addEventListener('shopify:section:load',event=>balanceLogos(event.target));
  new MutationObserver(records=>{
    records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)balanceLogos(node);}));
  }).observe(document.body,{childList:true,subtree:true});
  const requested=new URLSearchParams(location.search).get('brand');
  const inherited=requested==='uspe-vet'?'vet':requested==='uspe'?'uspe':'';
  const nativeBrand=document.documentElement.dataset.uspeBrand||'';
  // An explicit brand may carry across shared lab equipment and procurement,
  // but cannot relabel human pathology as veterinary or leak into AMC routes.
  const sharedLab=/casework|lab-casework|cabinet|uspe-cw-|laboratory-refrigerat|\/products\/ts-|^\/search$|\/pages\/(?:uspe-(?:options|quote-request)|purchase-order|quote|request-quote|equipment-user-manuals-library|request-received|warranty-policy|pet-aftercare-cooler-buyer-guide)/.test(location.pathname);
  const brand=sharedLab&&inherited?inherited:nativeBrand;
  const script=document.querySelector('script[data-uspe-brand-script]');
  if(location.pathname==='/pages/purchase-order'&&(new URLSearchParams(location.search).get('uspe_request')==='1'||/^uspe(?:-vet)?$/.test(requested||''))&&!window.AMCUSPEQuote&&script?.src){
    const quoteAsset=new URL(script.src,location.origin);
    quoteAsset.pathname=quoteAsset.pathname.replace(/uspe-brand-experience(?:-\d{8}-v\d+)?\.js$/,'amc-uspe-quote.js');
    quoteAsset.searchParams.set('uq','hoses-20261027-v4');
    const quoteStyle=document.createElement('link');
    quoteStyle.rel='stylesheet';
    quoteStyle.href=quoteAsset.href.replace(/amc-uspe-quote\.js/,'amc-uspe-quote.css');
    document.head.appendChild(quoteStyle);
    const quoteScript=document.createElement('script');
    quoteScript.src=quoteAsset.href;quoteScript.defer=true;
    document.head.appendChild(quoteScript);
  }
  const logo=brand==='vet'?script?.dataset.vetLogo:script?.dataset.uspeLogo;
  if(script?.src&&!document.querySelector('script[src*="/uspe-image-signature.js"]')){
    const signature=document.createElement('script'),url=new URL(script.src,location.origin);
    url.pathname=url.pathname.replace(/[^/]+$/,'uspe-image-signature.js');
    url.searchParams.set('v','20261029-model-caption-only-1');
    signature.src=url.href;signature.dataset.uspeSignatureLogo=script.dataset.uspeLogo;signature.dataset.vetSignatureLogo=script.dataset.vetLogo;
    document.body.append(signature);
  }
  const labPath=href=>/\/(pages\/us-pathology-equipment|pages\/uspe-|collections\/(autopsy|dissection|immersion|forensic|laboratory|veterinary|anatomy|morgue-cadaver)|products\/uspe-)/.test(href);
  function tagLabLink(a){
      if(a.closest('.uspe-site-header'))return;
      const href=a.getAttribute('href'),group=a.closest('details,.amc-hdr__item');
      if(brand&&href?.startsWith('/pages/build-a-quote')){
        a.href='/pages/uspe-quote-request?brand='+(brand==='vet'?'uspe-vet':'uspe');
        a.textContent='Request '+(brand==='vet'?'USPE PET':'USPE')+' equipment quote';
        return;
      }
      const groupText=group?.querySelector('summary,.amc-hdr__link')?.textContent||'';
      const labGroup=/autopsy|lab|pathology|veterinary|animal|necropsy/i.test(groupText);
      if(href?.startsWith('/')&&(labPath(href)||labGroup)){
        const vet=/vet|veterinary|animal|necropsy/i.test(href+' '+groupText)||/^(?:uspe vet\b|veterinary\b|animal science\b|necropsy\b)/i.test(a.textContent.trim());
        const u=new URL(href,location.origin);
        if(vet&&u.pathname==='/pages/us-pathology-equipment')u.pathname='/collections/veterinary-equipment';
        u.searchParams.set('brand',vet?'uspe-vet':'uspe');a.href=u.pathname+u.search+u.hash;
      }
  }
  function tagLabMenu(){document.querySelectorAll('header a[href],.amc-hdr a[href]').forEach(tagLabLink);}
  document.addEventListener('click',event=>{const a=event.target.closest('header a[href],.amc-hdr a[href]');if(a)tagLabLink(a);},true);
  if(!brand){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',tagLabMenu,{once:true});else tagLabMenu();return;}
  document.documentElement.dataset.uspeBrand=brand;
  if(document.querySelector('[data-uspe-brand-navigation]')?.dataset.brand!==brand){
    const template=document.querySelector('[data-uspe-nav-template="'+brand+'"]');
    const shell=document.querySelector('[data-amc-header-shell]');
    if(template&&shell)shell.replaceChildren(template.content.cloneNode(true));
  }
  const footerTemplate=document.querySelector('[data-uspe-owned-footer-template="'+brand+'"]')||document.querySelector('[data-uspe-footer-template="'+brand+'"]');
  const currentFooter=document.querySelector('footer[data-brand-context-footer],footer.amc-ftr,footer.amc-ft');
  if(footerTemplate&&currentFooter&&currentFooter.dataset.brandContextFooter!==brand)currentFooter.replaceWith(footerTemplate.content.cloneNode(true));
  const header=document.querySelector('[data-uspe-brand-navigation]');
  header?.querySelectorAll('a[href]').forEach(a=>{
    if(a.hasAttribute('data-amc-return')||a.hasAttribute('data-uspe-return'))return;
    const u=new URL(a.href,location.origin);
    if(u.origin===location.origin&&/^\/(?:pages|collections|products|search)(?:\/|$)/.test(u.pathname)&&!u.searchParams.has('brand')){u.searchParams.set('brand',brand==='vet'?'uspe-vet':'uspe');a.href=u.pathname+u.search+u.hash;}
  });
  const needsModelOptions=/^\/pages\/(?:uspe-quote-request|purchase-order|quote|request-quote)(?:\/|$)/.test(location.pathname)||!!document.querySelector('[data-uspe-model-options]');
  if(needsModelOptions&&header?.dataset.modelOptionsSource&&!document.querySelector('script[src*="/amc-uspe-model-options.js"]')){
    const modelScript=document.createElement('script');modelScript.src=header.dataset.modelOptionsSource;modelScript.defer=true;document.body.append(modelScript);
  }
  const categoryMenu=document.querySelector('.uspe-site-header__menu');
  const mobileHeader=window.matchMedia('(max-width:959px)');
  if(categoryMenu){
    categoryMenu.open=!mobileHeader.matches;
    mobileHeader.addEventListener('change',event=>{categoryMenu.open=!event.matches;});
  }
  document.querySelectorAll('.uspe-site-header__department').forEach(menu=>{
    menu.addEventListener('toggle',()=>{
      if(menu.open)document.querySelectorAll('.uspe-site-header__department[open]').forEach(other=>{if(other!==menu)other.open=false;});
    });
  });
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape')document.querySelectorAll('.uspe-site-header__department[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary')?.focus();});
  });
  document.addEventListener('click',event=>{
    if(!event.target.closest('.uspe-site-header__department'))document.querySelectorAll('.uspe-site-header__department[open]').forEach(menu=>menu.open=false);
  });
  const name=brand==='vet'?'USPE PET':'USPE',brandParam=brand==='vet'?'uspe-vet':'uspe';
  const home=brand==='vet'?'/collections/veterinary-equipment':'/pages/us-pathology-equipment';
  const petViews={'/pages/uspe-casework-options':'uspe-pet-options','/pages/uspe-casework-colors':'uspe-pet-colors','/pages/uspe-casework-hardware':'uspe-pet-hardware','/pages/uspe-laboratory-casework-specifications':'uspe-pet-specifications','/pages/uspe-casework-planner':'uspe-pet-builder','/pages/uspe-casework-bulk-package':'uspe-pet-package'};
  const withBrand=href=>{
    const u=new URL(href,location.origin);
    const isPetProduct=/^\/products\/uspe-pet-necropsy-[a-z0-9-]+\/?$/.test(u.pathname);
    u.searchParams.set('brand',isPetProduct?'uspe-vet':brandParam);
    if(isPetProduct&&(Number(window.Shopify?.theme?.id)===191243649326||new URLSearchParams(location.search).get('preview_theme_id')==='191243649326')){
      u.hash=u.pathname.split('/').filter(Boolean).pop();u.pathname='/pages/veterinary-necropsy-equipment';
      u.searchParams.set('view','uspe-pet-stations');u.searchParams.set('preview_theme_id','191243649326');
    }else if(brand==='vet'&&petViews[u.pathname])u.searchParams.set('view',petViews[u.pathname]);
    return u.pathname+u.search+u.hash;
  };
  const rewritePetLinks=root=>{
    const links=root.matches?.('a[href]')?[root]:root.querySelectorAll?.('a[href]')||[];
    links.forEach(a=>{const u=new URL(a.href,location.origin);if(u.origin===location.origin&&/^\/products\/uspe-pet-necropsy-/.test(u.pathname))a.href=withBrand(a.href);});
  };
  function readableBadges(root=document){
    const badges=root.matches?.('.amc-sale-tag')?[root]:root.querySelectorAll?.('.amc-sale-tag')||[];
    badges.forEach(badge=>{
      badge.style.setProperty('background','#fff','important');
      badge.style.setProperty('color','#202b33','important');
      badge.style.setProperty('-webkit-text-fill-color','#202b33','important');
    });
  }
  function apply(){
    // Display branding only. Native handles, product titles/IDs and quote keys stay intact.
    if(brand==='vet'){
      const normalizePetText=root=>{
        const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
        let node;
        while((node=walker.nextNode())){
          if(node.parentElement?.closest('script,style,textarea,code,pre'))continue;
          if(/USPE\s+VET(?:ERINARY)?\b/i.test(node.nodeValue))node.nodeValue=node.nodeValue.replace(/USPE\s+VET(?:ERINARY)?\b/gi,'USPE PET');
        }
      };
      const petMain=document.querySelector('main');
      if(petMain){
        normalizePetText(petMain);
        if(!petMain.dataset.uspePetTextReady){
          petMain.dataset.uspePetTextReady='true';
          new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{
            if(node.nodeType===1&&!node.matches('script,style'))normalizePetText(node);
          }))).observe(petMain,{childList:true,subtree:true});
        }
      }
      document.title=document.title.replace(/USPE\s+VET(?:ERINARY)?\b/gi,'USPE PET');
    }
    tagLabMenu();
    if(brand==='vet')document.querySelectorAll('[data-uspe-brand-navigation] a[href]').forEach(a=>{const u=new URL(a.href,location.origin);if(petViews[u.pathname])a.href=withBrand(a.href);});
    if(!document.querySelector('[data-uspe-brand-quote-dock]')){
      const dock=document.createElement('aside');
      dock.className='uspe-brand-quote-dock';
      dock.dataset.uspeBrandQuoteDock='true';
      dock.setAttribute('aria-label',name+' quote review');
      const mark=document.createElement('img');
      mark.src=logo;mark.alt=name;mark.width=140;mark.height=34;
      const identity=document.createElement('span');identity.dataset.uspeQuoteId='';identity.className='uspe-brand-quote-dock__identity';
      const identityBlock=document.createElement('div');identityBlock.className='uspe-brand-quote-dock__brand';identityBlock.append(mark,identity);
      const review=document.createElement('a');
      review.href=withBrand('/pages/uspe-quote-request');
      review.textContent=document.getElementById('lab360')?'Review casework request':'Review equipment quote';
      review.addEventListener('click',event=>{
        const prepare=document.getElementById('prepare-rfq');
        if(prepare&&!event.ctrlKey&&!event.metaKey){event.preventDefault();prepare.click();}
      });
      const syncDock=()=>{
        const api=window.AMCUSPEQuote,id=api?.getQuoteId?.(),state=api?.getQuoteIdentity?.();identity.textContent=id||'Specification quote';
        identity.title=state?.persistent?'Your quote reference follows this browser.':'Temporary quote reference. Browser storage or your privacy preferences may prevent it following you to another page.';
        identity.setAttribute('aria-label',(state?.persistent?'Quote reference ':'Temporary quote reference ')+(id||''));
        const items=api?.read?.()||[],count=items.reduce((s,i)=>s+(Number(i.qty)||1),0);
        review.textContent=document.getElementById('lab360')?'Review casework request':count?`Review quote · ${count} item${count===1?'':'s'}`:'Review equipment quote';
      };
      dock.append(identityBlock,review);document.body.append(dock);
      ['uspe:quote:change','uspe:quote:updated','uspe:quote:identity'].forEach(event=>document.addEventListener(event,syncDock));
      syncDock();window.addEventListener('load',syncDock,{once:true});
    }
    document.querySelectorAll('main p').forEach(p=>{
      if(p.children.length===1&&p.firstElementChild.tagName==='STRONG'&&p.textContent.trim().length>120)p.classList.add('uspe-balanced-body');
    });
    const headerLogo=document.querySelector('.amc-hdr__logo');
    if(headerLogo){
      headerLogo.href=home;headerLogo.setAttribute('aria-label',name+' equipment home');
      const img=headerLogo.querySelector('img');if(img){img.src=logo;img.removeAttribute('srcset');img.alt=name;headerLogo.querySelectorAll('source').forEach(x=>x.remove());}
    }
    document.querySelectorAll('main a[href]').forEach(a=>{
      const href=a.getAttribute('href');
      if(/^\/pages\/(uspe-(?:quote-request|casework[^/?#]*|options|laboratory-casework[^/?#]*)|purchase-order|quote|request-quote|equipment-user-manuals-library|warranty-policy)([?#]|$)/.test(href))a.href=withBrand(a.href);
      else if(/^\/(products|collections)\//.test(href)){
        const u=new URL(href,location.origin);
        u.searchParams.set('brand',/vet|veterinary|animal|necropsy/i.test(href)?'uspe-vet':brandParam);
        a.href=/^\/products\/uspe-pet-necropsy-/.test(u.pathname)?withBrand(u.href):u.pathname+u.search+u.hash;
      }
    });
    document.querySelectorAll('.amc-hdr a[href*="/pages/build-a-quote"]').forEach(a=>{a.href=withBrand('/pages/uspe-quote-request');a.textContent='Request '+name+' equipment quote';});
    document.querySelectorAll('main form[action*="/contact"]').forEach(form=>{let f=form.querySelector('input[name="contact[Equipment brand]"]');if(!f){f=document.createElement('input');f.type='hidden';f.name='contact[Equipment brand]';form.append(f);}f.value=name;});
    const title=document.querySelector('.amc-quote-page h1,.amc-qb-hero h1,.amc-uq__request-heading h1');if(title)title.textContent=name+' equipment quote';
    if(location.pathname==='/pages/purchase-order'){
      const heading=document.querySelector('main h1');
      if(heading)heading.textContent=name+' purchase orders & RFQs';
      document.title=name+' Purchase Orders & RFQs';
    }
    document.querySelectorAll('.amc-qb__logo,.amc-uq__brand,.amc-acct-pop__logo,.amc-cart-empty__logo,.uspe-product-brand__logo,[data-uspe-quote-logo]').forEach(img=>{img.src=logo;img.removeAttribute('srcset');img.alt=name;});
    balanceLogos();
    const main=document.querySelector('main');
    if(main){
      readableBadges(main);
      if(!main.dataset.uspeBadgesReady){
        main.dataset.uspeBadgesReady='true';
        new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1){readableBadges(node);rewritePetLinks(node);}}))).observe(main,{childList:true,subtree:true});
      }
    }
    document.querySelectorAll('[data-uspe-qty-input]').forEach(input=>{input.min='1';input.removeAttribute('max');});
    const quote=window.AMCQuote;if(quote&&quote.shareUrl&&!quote.__uspeBrandWrapped){const original=quote.shareUrl.bind(quote);quote.shareUrl=()=>{const u=new URL(original(),location.origin);u.searchParams.set('brand',brandParam);return u.href;};quote.__uspeBrandWrapped=true;}
  }
  window.USPEBrand={key:brand,name,logo,home,withBrand};
  document.addEventListener('click',event=>{
    const a=event.target.closest('a[href]');if(!a)return;
    const href=a.getAttribute('href');
    if(/^\/pages\/(uspe-quote-request|purchase-order|quote|request-quote)([?#]|$)/.test(href))a.href=withBrand(a.href);
    if(href?.startsWith('mailto:')){const u=new URL(href);const subject=u.searchParams.get('subject')||'';if(!subject.startsWith(name))u.searchParams.set('subject',name+' '+subject);a.href=u.href;}
  },true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply,{once:true});else apply();
  document.addEventListener('shopify:section:load',apply);
})();
